import React from 'react'
import Images from '../assets/images/Images';

const NoPaymentDue = ({ show, setShow }) => {
    return (
        show &&
        <>
            <div className="modal fade show" style={{ display: "block" }} id="CUREmodal" tabIndex="-1" aria-labelledby="CUREmodalLabel">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content" style={{ borderTop: "6px solid #1c70a8", width: "80%", marginLeft: "10%" }}>
                        <div className="modal-header">
                            <img src={Images.portalOne.cureLogo} style={{ height: "45px" }} />
                            <button id="CUREmodalCloseBtn" type="button" style={{ fontSize: "16px", fontWeight: "normal", color: "#478cbc", paddingRight: "40px", backgroundColor: "transparent", border: "none", opacity: "0.5" }}
                                className="close" data-dismiss="modal" aria-label="Close" onClick={() => setShow(false)}>
                                <span aria-hidden="true">CLOSE</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid" id="CUREmodalContainer">
                                <div className="col-xs-12 text-center">
                                    <br />
                                    <h4><span style={{ color: "red" }}>No payment due at this time.<br />
                                        Can not process payment.</span></h4>
                                    <br />
                                    <h5>If this is incorrect, please contact us via
                                        <br />
                                        Live Chat or call.</h5>
                                    <br />
                                    <br />
                                </div>
                            </div>
                            <div className="text-center" id="divCloseCUREmodal">
                                <button id="CloseBtn" type="button" style={{ width: "30%", backgroundColor: "transparent", border: "1px solid", padding: "10px" }}
                                    className="btn" data-dismiss="modal" aria-label="Close" onClick={() => setShow(false)}>
                                    <span aria-hidden="true">CLOSE</span>
                                </button>
                                <br />
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    )
}

export default NoPaymentDue